var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 12.0001C11.305 12.0001 10.87 11.8681 10.5 11.6209C10.13 11.3737 9.84157 11.0223 9.67127 10.6111C9.50097 10.2 9.45642 9.74759 9.54323 9.31112C9.63005 8.87466 9.84434 8.47375 10.159 8.15908C10.4737 7.8444 10.8746 7.63011 11.311 7.54329C11.7475 7.45648 12.1999 7.50103 12.611 7.67133C13.0222 7.84163 13.3736 8.13002 13.6208 8.50004C13.868 8.87005 14 9.30507 14 9.75008C14 10.3468 13.7629 10.9191 13.341 11.3411C12.919 11.7631 12.3467 12.0001 11.75 12.0001ZM11.75 1.5C9.56273 1.50248 7.46575 2.37248 5.91911 3.91913C4.37247 5.46579 3.50248 7.56279 3.5 9.75008C3.5 12.6939 4.86031 15.8139 7.4375 18.7736C8.59552 20.111 9.89886 21.3153 11.3234 22.3643C11.4495 22.4526 11.5998 22.5 11.7537 22.5C11.9077 22.5 12.058 22.4526 12.1841 22.3643C13.606 21.3149 14.9068 20.1106 16.0625 18.7736C18.6359 15.8139 20 12.6939 20 9.75008C19.9975 7.56279 19.1275 5.46579 17.5809 3.91913C16.0343 2.37248 13.9373 1.50248 11.75 1.5Z",
    fill: "#414042",
    stroke: "#414042",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsPoint);
export default __webpack_public_path__ + "static/media/gps-point.482f65aecdc0aa21a8dd02cdec854d95.svg";
export { ForwardRef as ReactComponent };